import {BaseFactory} from "../../../infrastructure/factories/base-factory";
import {BaseApiRequestModel} from "../../../infrastructure/models/base-api-request-model";
import {NewsResponseApiModel} from "../models/news.response-api-model";
import {NewsDataSource} from "../models/news-data-source";
import {NewsDomainModel} from "../models/news.domain-model";
import {NewsApiModel} from "../models/news.api-model";
import {BaseApiResponseModel} from "../../../infrastructure/models/base-api-response-model";
import {NewsSourceDomainModel} from "../models/news-source.domain-model";
import {DatetimeUtils} from "../../../infrastructure/utils/datetime-utils";
import {LoggerUtils} from "../../../infrastructure/utils/logger/logger-utils";
import {TermsUtils} from "../../../infrastructure/utils/terms-utils";


export class NewsFactory extends BaseFactory {
  dateTimeUtils: DatetimeUtils;

  static injectables = [...BaseFactory.injectables, DatetimeUtils];

  constructor(logger: LoggerUtils, terms: TermsUtils, dateTimeUtils: DatetimeUtils) {
    super(logger, terms);

    this.dateTimeUtils = dateTimeUtils;
  }
  createResponse(apiModel: NewsResponseApiModel, request: BaseApiRequestModel) {
    const responseApiModel: NewsResponseApiModel = new NewsResponseApiModel(apiModel, request);

    return responseApiModel;
  }

  createDomainModel(response: NewsResponseApiModel): NewsDataSource {
    const newsSources = this.createDomainMap(response.newsSources, NewsSourceDomainModel);
    const news: Array<NewsDomainModel> = response?.news?.map((newsApiModel: NewsApiModel) => {
      const date: Date = this.dateTimeUtils.fromISO(newsApiModel.publishDate);

      return new NewsDomainModel(newsApiModel, newsSources.get(newsApiModel.sourceId), date)
    });
    const newsDataSource: NewsDataSource = new NewsDataSource(response, news);

    return newsDataSource;
  }

  updateApiResponseModel(response: BaseApiResponseModel, delta: BaseApiResponseModel) {
    this.updateApiModel(response, delta);

    if (delta?.news) {
      response.news = delta.news;
    }

    return response;
  }
}
